import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Copy,
  Container,
  Wrapper,
  Bold,
  KeyboardView
} from "app/NativeComponents/common";
import {
  NewHeader,
  SelectItem,
  InlineButton,
  BottomNavBar,
  ConfirmInlineButton,
  GhostButton
} from "app/NativeComponents/snippets";
import MainHeader from "app/DealMachineCore/reuseable/MainHeader";

import {
  popSidePanel,
  pushSidePanel,
  changeTab,
  tabNavigation,
  getBilling,
  getSendingQueueCounts,
  setDarkMode,
  updateUserSettings,
  logout,
  popAllSidePanels,
  openUrl
} from "app/NativeActions";

class WorkspaceAdminSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dark_mode: props.dark_mode
    };
  }

  componentDidMount() {
    this.props.getBilling({ token: this.props.token, type: "deal_credits" });
    this.props.getBilling({ token: this.props.token, type: "get_cards" });
    this.props.getSendingQueueCounts({
      token: this.props.token
    });
  }

  handleBack() {
    this.props.popSidePanel();
  }

  render() {
    const {
      user,
      source_of_truth,
      deal_credits,
      deal_credits_loading,
      device,
      isMobile,
      colors
    } = this.props;

    return (
      <Container
        style={{
          display: "flex",
          alignSelf: "stretch",
          backgroundColor: colors.card_color
        }}
      >
        <NewHeader
          title={"Account & Settings"}
          leftButton={{
            icon: isMobile ? "arrow-back" : "close",
            onPress: () => {
              this.handleBack();
            }
          }}
        />

        <KeyboardView style={{ flex: 1 }}>
          <SelectItem
            innerStyle={{ paddingTop: 10, paddingBottom: 10 }}
            select_type="profile_pic"
            user={this.props.user}
            noPress={true}
            description={user?.company}
            renderRight={() => {
              return (
                <InlineButton
                  onPress={() => {
                    this.props.pushSidePanel({
                      slug: "edit_profile",
                      overlay: true
                    });
                  }}
                  icon_right="keyboard-arrow-right"
                >
                  Edit Profile
                </InlineButton>
              );
            }}
          >
            {user?.name ? user.name : user?.email}
          </SelectItem>

          <SelectItem
            select_type="none"
            icon="keyboard-arrow-right"
            onPress={() => {
              this.props.pushSidePanel({
                slug: "billing_settings",
                overlay: true
              });
            }}
          >
            Billing
          </SelectItem>

          <SelectItem
            select_type="none"
            icon="keyboard-arrow-right"
            onPress={() => {
              this.props.pushSidePanel({
                slug: "admin_app_settings",
                overlay: true
              });
            }}
          >
            Application Settings
          </SelectItem>

          <SelectItem
            select_type="none"
            icon="keyboard-arrow-right"
            onPress={() => {
              this.props.pushSidePanel({
                slug: "global_postcards",
                overlay: true
              });
            }}
          >
            Global Postcards
          </SelectItem>
        </KeyboardView>

        {this.props.device == "desktop" ? (
          <>
            <Row style={{ justifyContent: "space-between" }}>
              <ConfirmInlineButton
                confirm_text="Really Logout?"
                loading_text="Logging Out..."
                loading={this.state.deleting}
                onPress={() => {
                  this.setState(
                    {
                      deleteing: true
                    },
                    () => {
                      this.props.logout();
                    }
                  );
                }}
              >
                Logout
              </ConfirmInlineButton>
              <InlineButton
                select_type="toggle"
                icon={
                  this.state.dark_mode == "dark_mode"
                    ? "toggle-on"
                    : "toggle-off"
                }
                onPress={() => {
                  this.setState({
                    dark_mode:
                      this.state.dark_mode != "dark_mode"
                        ? "dark_mode"
                        : "dark_mode_off"
                  });
                  this.props.setDarkMode(
                    this.state.dark_mode != "dark_mode"
                      ? "dark_mode"
                      : "dark_mode_off"
                  );
                  this.props.updateUserSettings({
                    token: this.props.token,
                    type: "dark_mode",
                    value:
                      this.state.dark_mode != "dark_mode"
                        ? "dark_mode"
                        : "dark_mode_off"
                  });
                }}
              >
                Dark Mode
              </InlineButton>
            </Row>
            <BottomNavBar>
              <Row>
                <Wrapper style={{ flex: 1 }}>
                  <Row>
                    <InlineButton
                      style={{ marginRight: 0, marginLeft: 0 }}
                      textStyle={{
                        color: colors.light_text_color,
                        textAlign: "center",
                        fontSize: 12
                      }}
                      onPress={() => {
                        openUrl("https://dealmachine.com/privacy-policy");
                      }}
                    >
                      Privacy Policy
                    </InlineButton>

                    <InlineButton
                      style={{ marginRight: 0, marginLeft: 0 }}
                      textStyle={{
                        color: colors.light_text_color,
                        textAlign: "center",
                        fontSize: 12
                      }}
                      onPress={() => {
                        openUrl("https://dealmachine.com/terms-of-service");
                      }}
                    >
                      Terms Of Service
                    </InlineButton>
                  </Row>
                </Wrapper>
                <Copy
                  style={{
                    color: colors.light_text_color,
                    textAlign: "center",
                    fontSize: 12,
                    paddingRight: 10,
                    paddingLeft: 10
                  }}
                >
                  © DealMachine {new Date().getFullYear()}
                </Copy>
              </Row>
            </BottomNavBar>
          </>
        ) : (
          <>
            <BottomNavBar>
              <Row style={{ justifyContent: "space-between" }}>
                <ConfirmInlineButton
                  confirm_text="Really Logout?"
                  loading_text="Logging Out..."
                  loading={this.state.deleting}
                  onPress={() => {
                    this.setState(
                      {
                        deleteing: true
                      },
                      () => {
                        this.props.logout();
                      }
                    );
                  }}
                >
                  Logout
                </ConfirmInlineButton>
                <InlineButton
                  select_type="toggle"
                  icon={
                    this.state.dark_mode == "dark_mode"
                      ? "toggle-on"
                      : "toggle-off"
                  }
                  onPress={() => {
                    this.setState({
                      dark_mode:
                        this.state.dark_mode != "dark_mode"
                          ? "dark_mode"
                          : "dark_mode_off"
                    });
                    this.props.setDarkMode(
                      this.state.dark_mode != "dark_mode"
                        ? "dark_mode"
                        : "dark_mode_off"
                    );
                    this.props.updateUserSettings({
                      token: this.props.token,
                      type: "dark_mode",
                      value:
                        this.state.dark_mode != "dark_mode"
                          ? "dark_mode"
                          : "dark_mode_off"
                    });
                  }}
                >
                  Dark Mode
                </InlineButton>
              </Row>
            </BottomNavBar>
          </>
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({
  auth,
  settings,
  native,
  partner,
  billing,
  mailer
}) => {
  const { token, user } = auth;
  const { colors, dark_mode } = settings;
  const { platform, device, isMobile } = native;
  const { is_partner } = partner;
  const { sending_queue_counts } = mailer;

  const { deal_credits, deal_credits_loading, source_of_truth } = billing;

  return {
    token,
    user,
    colors,
    dark_mode,
    device,
    isMobile,
    platform,
    deal_credits,
    is_partner,
    deal_credits_loading,
    sending_queue_counts,
    source_of_truth
  };
};

export default connect(mapStateToProps, {
  popSidePanel,
  pushSidePanel,
  changeTab,
  tabNavigation,
  getSendingQueueCounts,
  getBilling,
  setDarkMode,
  updateUserSettings,
  logout,
  popAllSidePanels
})(WorkspaceAdminSettings);
